/**
 * Get the RiseAI API base URL
 * In development (localhost), uses '/api' which is proxied by setupProxy.js to avoid CORS
 * Set REACT_APP_RISEAI_API_URL to override (use full URL for direct connection)
 */
export const getApiBaseUrl = () => {
  if (process.env.REACT_APP_RISEAI_API_URL) {
    return process.env.REACT_APP_RISEAI_API_URL;
  }
  // In development (localhost), use proxy path to avoid CORS
  if (process.env.NODE_ENV === 'development' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    return '/api'; // This will be proxied by setupProxy.js to https://riseai-dev.netrise.io/api
  }
  // In development and production, use direct URL
  return 'https://riseai-dev.netrise.io/api';
};

/**
 * Get the chat endpoint URL
 */
export const getChatEndpointUrl = () => {
  let baseUrl;
  if (process.env.REACT_APP_RISEAI_API_URL) {
    baseUrl = process.env.REACT_APP_RISEAI_API_URL.replace('/api', '');
  } else if (process.env.NODE_ENV === 'development' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    // Use relative path for proxy - /run_sse will be proxied
    baseUrl = '';
  } else {
    baseUrl = 'https://riseai-dev.netrise.io';
  }

  // Build the chat endpoint URL: /run_sse (proxied in localhost, direct in development and production)
  return baseUrl ? `${baseUrl}/run_sse` : '/run_sse';
};
